export default "__VITE_ASSET__18d07e45__"